import HeaderComponent from './headerComponent'
export default HeaderComponent
